<div>
  <div class="text-center text-2xl mb-4">
    {{'section.notification-wizard.filter' | translate}}
  </div>

  <div class="border-slate-200">
    <div class="flex flex-col flex-auto sm:mb-18 px-0 md:px-8">

      <!-- Company Selection Pills - Show in User and Group modes -->
      <div *ngIf="isUserMode || isGroupMode" class="mb-1">
        <div class="flex flex-wrap">
          <button
            type="button"
            [ngClass]="selectedCompanyId === null ? 'bg-yellow-500 text-white border-yellow-500' : 'bg-white text-gray-700 border-gray-300'"
            class="px-4 py-2 font-medium transition-colors duration-200 border rounded-l-lg hover:bg-yellow-400 hover:text-white"
            (click)="selectCompany(null)">
            {{ "section.newss.all" | translate }}
          </button>
          <button
            *ngFor="let company of notificationWizard.companyList; let last = last"
            type="button"
            [ngClass]="selectedCompanyId === company.id ? 'bg-yellow-500 text-white border-yellow-500' : 'bg-white text-gray-700 border-gray-300'"
            [class.rounded-r-lg]="last"
            [class.border-l-0]="true"
            class="px-4 py-2 font-medium transition-colors duration-200 border hover:bg-yellow-400 hover:text-white"
            (click)="selectCompany(company.id)">
            {{ company.name }}
          </button>
        </div>
      </div>

      <!-- User/Group Selection Toggle -->
      <div class="mb-6">
        <div class="flex items-center space-x-1 bg-gray-100 rounded-lg p-1 w-fit">
          <button
            type="button"
            (click)="setUserMode()"
            class="px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200"
            [ngClass]="isUserMode ? 'bg-yellow-400 text-white shadow-sm' : 'text-gray-600 hover:text-gray-800'">
            {{ 'section.notification-wizard.users' | translate }}
          </button>
          <button
            type="button"
            (click)="setGroupMode()"
            class="px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200"
            [ngClass]="isGroupMode ? 'bg-yellow-400 text-white shadow-sm' : 'text-gray-600 hover:text-gray-800'">
            {{ 'section.notification-wizard.groups' | translate }}
          </button>
        </div>
      </div>

      <!-- Selected Count Display -->
      <div class="mb-4 text-sm text-gray-600">
        <div *ngIf="isUserMode">
          {{ 'section.notification-wizard.selectedUsers' | translate }}: {{ getSelectedUsersCount() }}
        </div>
        <div *ngIf="isGroupMode">
          {{ 'section.notification-wizard.selectedGroups' | translate }}: {{ getSelectedGroupsCount() }}
          ({{ 'section.notification-wizard.totalUsers' | translate }}: {{ getSelectedGroupsUserCount() }})
        </div>
      </div>

      <!-- Search Box -->
      <div class="mb-4">
        <mat-form-field appearance="outline" class="w-80">
          <mat-label>Vyhledat</mat-label>
          <input matInput
                 [(ngModel)]="searchTerm"
                 (ngModelChange)="onSearchChange()"
                 type="text">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>

      <!-- User Selection Table -->
      <div *ngIf="isUserMode" class="border mb-8 mr-8 md:mb-0 md:mr-0">
        <div
          class="users-grid z-10 top-0 grid gap-4 shadow py-2
                              text-md font-semibold bg-gray-50 dark:bg-black dark:bg-opacity-5">

          <div class="text-left pl-[14px]">
          </div>
          <div class="text-left self-center">
            {{"section.users.name" | translate}}
          </div>

          <div class="text-left self-center">
            {{"section.users.email" | translate}}
          </div>

          <div class="text-left self-center">
            Společnost(i)
          </div>

        </div>

        <!-- Loading indicator -->
        <div *ngIf="isLoading" class="text-center justify-center mt-8 mb-8">
          <i class="icon-size-5 far fa-spinner animate-spin"></i>
        </div>

        <!-- Table rows -->
        <ng-container *ngIf="!isLoading">
          <ng-container *ngFor="let user of currentPageUsers">
            <div
              class="users-grid grid items-center gap-4 border-b bg-white text-md
                                       hover:cursor-pointer hover:bg-slate-100"
              [ngClass]="{'text-slate-300 bg-slate-100': !selectedUserIds.has(user.id)}">

              <div>
                <mat-checkbox
                  [checked]="selectedUserIds.has(user.id)"
                  (change)="onUserCheckboxChange(user)">
                </mat-checkbox>
              </div>

              <div class="text-left">
                {{user?.firstname}} {{user?.lastname}}
              </div>

              <div class="text-left">
                {{user.email}}
              </div>

              <div class="text-left">
                <span *ngIf="user?.companies && user.companies.length > 0">{{ getUserCompanies(user) }}</span>
                <span *ngIf="!user?.companies || user.companies.length === 0" class="text-gray-400">-</span>
              </div>

            </div>
          </ng-container>
        </ng-container>

        <!-- Paginator -->
        <ag-grid-paginator
          [currentPage]="currentPage"
          [totalCount]="totalCount"
          [pageSize]="pageSize"
          [isLoading]="isLoading"
          (pageChange)="loadPage($event)"
          (pageSizeChange)="pageSize = $event; loadPage(1)">
        </ag-grid-paginator>
      </div>

      <!-- Group Selection Table -->
      <div *ngIf="isGroupMode" class="border mb-8 mr-8 md:mb-0 md:mr-0">
        <div
          class="users-grid z-10 top-0 grid gap-4 shadow py-2
                              text-md font-semibold bg-gray-50 dark:bg-black dark:bg-opacity-5">

          <div class="text-left pl-[14px]">
          </div>
          <div class="text-left self-center">
            {{"section.groups.name" | translate}}
          </div>

          <div class="text-left self-center">
            {{"section.groups.usersCount" | translate}}
          </div>

          <div class="text-left self-center">
              Společnost
          </div>

        </div>

        <!-- Loading indicator -->
        <div *ngIf="isLoading" class="text-center justify-center mt-8 mb-8">
          <i class="icon-size-5 far fa-spinner animate-spin"></i>
        </div>

        <!-- Table rows -->
        <ng-container *ngIf="!isLoading">
          <ng-container *ngFor="let group of currentPageGroups">
            <div
              class="users-grid grid items-center gap-4 border-b bg-white text-md
                                       hover:cursor-pointer hover:bg-slate-100"
              [ngClass]="{'text-slate-300 bg-slate-100': !selectedGroupsMap.has(group.id)}">

              <div>
                <mat-checkbox
                  [checked]="selectedGroupsMap.has(group.id)"
                  (change)="onGroupCheckboxChange(group)">
                </mat-checkbox>
              </div>

              <div class="text-left">
                {{group?.name}}
              </div>

              <div class="text-left">
                {{getGroupUserCount(group)}}
              </div>

              <div class="text-left">
                <span *ngIf="group?.companies && group.companies.length > 0">{{ getGroupCompanies(group) }}</span>
                <span *ngIf="!group?.companies || group.companies.length === 0" class="text-gray-400">-</span>
              </div>

            </div>
          </ng-container>
        </ng-container>

        <!-- Paginator -->
        <ag-grid-paginator
          [currentPage]="currentPage"
          [totalCount]="totalCount"
          [pageSize]="pageSize"
          [isLoading]="isLoading"
          (pageChange)="loadPage($event)"
          (pageSizeChange)="pageSize = $event; loadPage(1)">
        </ag-grid-paginator>
      </div>

      <!-- Submit Button -->
      <button mat-button
              mat-stroked-button
              class="mt-4 max-w-[200px] self-center"
              (click)="save()"
              type="button">
        {{'section.notification-wizard.users_submit' | translate}}
        <i class="far fa-check"></i>
      </button>

    </div>
  </div>
</div>
